import React from 'react';
import {NextPage} from 'next';
import {FaqSections, HeaderSectionFAQ, QuestionsSectionFAQ} from 'containers/common/sections/faq';
import commonStores from 'stores/common';
import common from 'stores/common';
import {Page} from 'containers/common/sections/layout';
import { createGetServerSideProps, StaticPageProps } from "evcharging/app";
import {I18nPage} from "i18n/types/pages.enum";

const FaqPage: NextPage<StaticPageProps> = ({ initialState, page }) => {
  common.initState(initialState);

  return (
    <Page title={page.meta_title} description={page.meta_description} locales={page.locales} showTransparentBg>
      <HeaderSectionFAQ />
      <FaqSections />
      <QuestionsSectionFAQ />
    </Page>
  );
};

export const getServerSideProps = createGetServerSideProps(undefined, async () => {
  const { faqStore } = commonStores;
  const { searchFAQs } = faqStore;
  await searchFAQs();
  const { faqData } = faqStore;

  return {
    storesModule: 'common',
    initialState: {
      faqStore: { faqData },
    },
  };
}, [I18nPage.Faq]);

export default FaqPage;
